import React from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Navbar from "../layouts/Navbar";
import Swal from "sweetalert2";
function UserEdit() {
    const { id_admin } = useParams();
    const navigate = useNavigate();

    const [formValue, setFormValue] = React.useState({
        username: "",
        email: "",
    });

    // function "fetchData"
    const fetchData = React.useCallback(async () => {
        try {
            const token = localStorage.getItem("token");
            if (!token) {
                navigate("/");
                return;
            }

            // Set token in axios headers
            axios.interceptors.request.use(
                (config) => {
                    config.headers.authorization = token;
                    return config;
                },
                (error) => {
                    return Promise.reject(error);
                }
            );
            // fetching
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/users/readUserById/${id_admin}`
            );
            // get response data
            const data = response.data;
            // assign response data to state "formValue"
            setFormValue({
                username: data.username,
                email: data.email,
            });
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    }, [id_admin]);

    React.useEffect(() => {
        // call method "fetchData"
        fetchData();
    }, [fetchData, id_admin]);

    const handleChange = (event) => {
        setFormValue({
            ...formValue,
            [event.target.name]: event.target.value,
        });
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        // store the states in the form data
        const updatedData = {
            username: formValue.username,
            email: formValue.email,
        };

        try {
            // make axios put request
            const response = await axios.put(
                `${process.env.REACT_APP_API_URL}/users/updateUser/${id_admin}`,
                updatedData,
                {
                    headers: { "Content-Type": "application/json" },
                }
            );

            Swal.fire({
                title: "Success",
                text: "Data berhasil diperbarui",
                icon: "success",
            });
            navigate("/user");
        } catch (error) {
            console.error("Error updating data:", error);
            if (error.response) {
                alert(`Error: ${error.response.data.message}`);
            } else {
                alert("Terjadi kesalahan saat menyimpan data.");
            }
        }
    };

    return (
        <div className="wrapper">
            <Header />
            <Navbar />
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1>Administrasi</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item text-decoration-none">
                                        <Link className="text-decoration-none" to="/">
                                            Administrasi
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item active">Admin</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title">Edit Admin</h3>
                                    </div>
                                    <div className="card-body">
                                        <form onSubmit={handleSubmit}>
                                            <div className="card-body">
                                                <div className="form-group">
                                                    <label>Username</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="username"
                                                        placeholder="Masukkan Username"
                                                        onChange={handleChange}
                                                        value={formValue.username}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Email</label>
                                                    <input
                                                        type="email"
                                                        className="form-control"
                                                        name="email"
                                                        placeholder="Masukkan Email"
                                                        onChange={handleChange}
                                                        value={formValue.email}
                                                    />
                                                </div>
                                                <div>
                                                    <button type="submit" className="btn btn-info">
                                                        Simpan
                                                    </button>
                                                    <Link to="/user">
                                                        <button
                                                            type="button"
                                                            className="btn btn-secondary ml-2"
                                                        >
                                                            Batal
                                                        </button>
                                                    </Link>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default UserEdit;
